import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FAQRepository } from '@/core/domain/faqs/repositories/faqs.repository';
import { getFAQsUseCase } from '@/core/domain/faqs/usecases/faqs.usecase';
import { FAQsImplRepository } from './faqs-impl.repository';

const getFAQsUseCaseFactory = (faqRepository: FAQRepository) =>
    new getFAQsUseCase(faqRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: getFAQsUseCase,
            useFactory: getFAQsUseCaseFactory,
            deps: [FAQRepository],
        },
        {
            provide: FAQRepository,
            useClass: FAQsImplRepository,
        },
    ],
})
export class FAQsDataModule {}
